import { createSelector } from '@reduxjs/toolkit';
import _keyBy from 'lodash-es/keyBy';

import {
  ADMIN_JOBS_DASHBOARD_SYSTEM_PAGE_ROUTE,
  ADMIN_JOBS_DASHBOARD_SYSTEM_WIDGET_PAGE_ROUTE,
} from '../../constants/routes';
import type { AppState } from '../../store/types';
import { defaultWidgets } from './default_widgets';
import { asJobWidgets, type JobWidgetSchemaPatched } from './types';

// User widgets
const getUserWidgets = (state: AppState): JobWidgetSchemaPatched[] =>
  asJobWidgets(state.settings.merged.jobs_dashboard?.widgets ?? defaultWidgets);
export const selectUserWidgets = createSelector(
  getUserWidgets,
  (widgets) => widgets,
);

// System widgets
const getSystemWidgets = (state: AppState): JobWidgetSchemaPatched[] =>
  asJobWidgets(state.settings.system.jobs_dashboard?.widgets ?? defaultWidgets);
export const selectSystemWidgets = createSelector(
  getSystemWidgets,
  (widgets) => widgets,
);

const getRoute = (state: AppState) => state.routeParams.route;
export const selectIsSystemDashboardPage = createSelector(getRoute, (route) =>
  [
    ADMIN_JOBS_DASHBOARD_SYSTEM_PAGE_ROUTE,
    ADMIN_JOBS_DASHBOARD_SYSTEM_WIDGET_PAGE_ROUTE,
  ].includes(route),
);

export const selectWidgetsRaw = createSelector(
  [selectIsSystemDashboardPage, getUserWidgets, getSystemWidgets],
  (isSystemDashboardPage, userWidgets, systemWidgets) =>
    isSystemDashboardPage ? systemWidgets : userWidgets,
);

export const getIsWidgetsListStateInitialized = (state: AppState) =>
  Object.keys(state.jobsWidgetsLists).length > 0;

// Guard widgets list so it returns widgets only if corresponding widget reducers are already initialized
export const selectWidgets = createSelector(
  [selectWidgetsRaw, getIsWidgetsListStateInitialized],
  (widgets, isWidgetsListStateInitialized) =>
    !isWidgetsListStateInitialized ? [] : widgets,
);

export const selectWidgetsMap = createSelector([selectWidgets], (widgets) =>
  _keyBy(widgets, 'id'),
);
